export const opacity = {
  text: {
    0: 'text-opacity-0',
    5: 'text-opacity-5',
    10: 'text-opacity-10',
    20: 'text-opacity-20',
    25: 'text-opacity-25',
    30: 'text-opacity-30',
    40: 'text-opacity-40',
    50: 'text-opacity-50',
    60: 'text-opacity-60',
    70: 'text-opacity-70',
    80: 'text-opacity-80',
    90: 'text-opacity-90',
    95: 'text-opacity-95',
    100: 'text-opacity-100',
  },
}

export type TextOpacity = keyof typeof opacity.text
